import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[ceInputDecimal]'
})
export class InputDecimalDirective {

  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'];

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Permitir teclas especiales
    if (this.specialKeys.indexOf(event.key) !== -1 ||
        // Permitir combinaciones de teclas Ctrl/Cmd+A, C, V, X
        (event.ctrlKey || event.metaKey) && (/^[acvx]$/i.test(event.key))) {
      return;
    }

    let current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);

    // Permitir punto decimal solo si no existe ya
    if (event.key === '.' && !current.includes('.')) {
        return;
    }

    // Validar si es un número válido (permitiendo decimales)
    // Regex: Solo dígitos y un punto opcional
    if (next && !String(next).match(/^[0-9]*\.?[0-9]*$/)) {
      event.preventDefault();
    }
  }
}

